// Libraries
import { MouseEventHandler } from 'react';
import { useMediaQuery } from 'react-responsive';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft } from '@fortawesome/pro-regular-svg-icons';

// Libraries
import { ReactNode } from 'react';

// Utilities
import {
    mediaPortraitMobile,
    mediaLandscapeMobile,
} from '../../../utils/misc/mediaQueries';

// Styles
import styles from './Menu.module.css';

/**
 * @function Menu
 * Describe the component's function
 *
 * @example
 * return (
 *   <Menu header={<></>} onClose={() => false}>{children}</Menu>
 * )
 */
function Menu({ header, children, onClose }: MenuProps): JSX.Element {
    const isPortraitMobile = useMediaQuery(mediaPortraitMobile);
    const isLandscapeMobile = useMediaQuery(mediaLandscapeMobile);
    return (
        <aside className={styles.container}>
            <header className={styles.header}>
                {header}
                {(isPortraitMobile || isLandscapeMobile) && (
                    <button
                        type="button"
                        className={styles.close}
                        onClick={onClose}
                    >
                        <FontAwesomeIcon icon={faChevronLeft} />
                    </button>
                )}
            </header>
            <div className={styles.body}>{children}</div>
            {!isPortraitMobile && !isLandscapeMobile && (
                <footer className={styles.footer}>
                    <button
                        type="button"
                        className={styles.cancel}
                        onClick={onClose}
                    >
                        Close
                    </button>
                </footer>
            )}
        </aside>
    );
}

/**
 * @interface MenuProps
 * Describes the properties required for the Menu component
 *
 * @property {ReactNode} header
 * @property {ReactNode} children
 */
export interface MenuProps {
    header: ReactNode;
    children: ReactNode;
    onClose: MouseEventHandler<HTMLButtonElement>;
}

// Exports
export default Menu;
